import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { KeycloakInitOptions } from 'keycloak-js';
import { KeycloakService } from 'keycloak-angular';
import { SidenavService } from 'src/app/services/sidenav.service';
import { environment } from 'src/environments/environment';

const url = environment.apiType + '://' + environment.apiUrl;

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit {

  @ViewChild(MatSidenav) sidenav!: MatSidenav;

  showLogin: boolean = true;

  default: KeycloakInitOptions = {
    redirectUri: url
    //redirectUri: 'http://192.168.2.197'
    //redirectUri: 'http://localhost:4200'
    //redirectUri: 'https://ditect.wings-ict-solutions.dev/'
    //redirectUri: 'http://localhost:4201'
  }

  constructor(private sidenavService: SidenavService, private keycloak: KeycloakService) { }

  ngOnInit() {
    this.keycloak.isLoggedIn().then(res => {
      if (res == true) {
        this.showLogin = false;
      }
      else {
        this.showLogin = true;
      }
    });
  }

  logout() {
    this.keycloak.logout(this.default.redirectUri);
  }

  login() {
    this.keycloak.login(this.default);
  }

  toggleSidenav() {
    this.sidenavService.toggle();
  }
}
